// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_TREATMENT_CATEGORY,
    SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS,
    SETTING_UPDATE_TREATMENT_CATEGORY,
    SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS,
    SETTING_LOAD_TREATMENT_CATEGORY,
    SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS,
    SETTING_DELETE_TREATMENT_CATEGORY,
    SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS,

    SETTING_LOAD_TREATMENT,
    SETTING_LOAD_TREATMENT_SUCCESS,
    SETTING_CREATE_TREATMENT,
    SETTING_CREATE_TREATMENT_SUCCESS,
    SETTING_UPDATE_TREATMENT,
    SETTING_UPDATE_TREATMENT_SUCCESS,
    SETTING_DELETE_TREATMENT,
    SETTING_DELETE_TREATMENT_SUCCESS,
    SETTING_UPDATE_TREATMENT_STATUS,
    SETTING_UPDATE_TREATMENT_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getTreatmentCategory --------------------- //
export const getTreatmentCategory = (data, token) => ({
    type: SETTING_LOAD_TREATMENT_CATEGORY,
    payload: data,
    token
});
export const getTreatmentCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createTreatmentCategory --------------------- //
export const addTreatmentCategory = (data, token) => ({
    type: SETTING_CREATE_TREATMENT_CATEGORY,
    payload: data,
    token
});
export const addTreatmentCategorySuccess = () => ({
    type: SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS,
});

// // -------------------- updateTreatmentCategory --------------------- //
export const updateTreatmentCategory = (data, token) => ({
    type: SETTING_UPDATE_TREATMENT_CATEGORY,
    payload: data,
    token
});
export const updateTreatmentCategorySuccess = () => ({
    type: SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS,
});

// // -------------------- deleteTreatmentCategory --------------------- //
export const deleteTreatmentCategory = (data, token) => ({
    type: SETTING_DELETE_TREATMENT_CATEGORY,
    payload: data,
    token
});
export const deleteTreatmentCategorySuccess = () => ({
    type: SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS,
});

// // -------------------- getTreatment --------------------- //
export const getTreatment = (data, token) => ({
    type: SETTING_LOAD_TREATMENT,
    payload: data,
    token
});
export const getTreatmentSuccess = (data, list) => ({
    type: SETTING_LOAD_TREATMENT_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createTreatment --------------------- //
export const createTreatment = (data, token) => ({
    type: SETTING_CREATE_TREATMENT,
    payload: data,
    token
});
export const createTreatmentSuccess = () => ({
    type: SETTING_CREATE_TREATMENT_SUCCESS,
});

// // -------------------- updateTreatment --------------------- //
export const updateTreatment = (data, token) => ({
    type: SETTING_UPDATE_TREATMENT,
    payload: data,
    token
});
export const updateTreatmentSuccess = () => ({
    type: SETTING_UPDATE_TREATMENT_SUCCESS,
});

// // -------------------- deleteTreatment --------------------- //
export const deleteTreatment = (data, token) => ({
    type: SETTING_DELETE_TREATMENT,
    payload: data,
    token
});
export const deleteTreatmentSuccess = () => ({
    type: SETTING_DELETE_TREATMENT_SUCCESS,
});

// // -------------------- updateChangeStatusTreatment --------------------- //
export const updateChangeStatusTreatment = (data, token) => ({
    type: SETTING_UPDATE_TREATMENT_STATUS,
    payload: data,
    token
});
export const updateChangeStatusTreatmentSuccess = () => ({
    type: SETTING_UPDATE_TREATMENT_STATUS_SUCCESS,
});
